<div class="cdp-filter-btn" [hcPop]="supportLevelOptionsPop">
    <span class="icon-left {{ selectedSupportLevelOption.ico }}"></span>
    <span class="cdp-filter-btn-selection">{{ selectedSupportLevelOption.name }}</span>
    <span class="icon-right icon-chev-down"></span>
</div>

<hc-pop #supportLevelOptionsPop [showArrow]="false" horizontalAlign="start">
    <div class="support-level-options">
        @for (option of supportLevelOptions; track option.supportLevel) {
            <ng-container *ngTemplateOutlet="optionTemplate; context: { option: option }"></ng-container>
        }

        <ng-template #optionTemplate let-option="option">
            <div
                #supportLevelOption
                tabindex="0"
                class="support-level-option"
                [class.selected-option]="option.supportLevel === selectedSupportLevelOption.supportLevel"
                (click)="selectSupportLevel(option.supportLevel)"
                title="{{
                    option.supportLevel === selectedSupportLevel
                        ? 'Current status'
                        : 'Switch to this status (' + option.name + ')'
                }}"
                (keydown)="onRowKeydown($event, option)"
            >
                <span class="support-level-option-name">
                    <span *ngIf="option.ico" class="icon-left {{ option.ico }}"></span>
                    <span class="support-level-option-name-inner">{{ option.name }}</span>
                </span>
            </div>
        </ng-template>
    </div>
</hc-pop>
